import { takeLeading, select } from 'redux-saga/effects';
import { callApi } from 'helpers/saga-helpers';
import { get, isNull } from 'lodash';

import {
  REQUEST_VALIDATED_CLAIMS,
  REQUEST_SEARCH,
} from 'containers/ValidatedClaimsPage/constants';
import userToken from 'containers/services/security/access-token-storage';
import {
  setValidatedClaims,
  setSearch,
} from 'containers/ValidatedClaimsPage/actions';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';

export function* requestValidatedClaims(action: any): Generator<unknown> {
  const { status, page, pageSize } = action;
  const token = yield select(makeSelectKeycloakToken());
  if (isNull(token)) return;
  const path = `/corporeal/common/claims?status=${status}&page=${page}&pageSize=${pageSize}&isIntervenant=true`;
  const options = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  yield callApi(path, {}, options, [], setValidatedClaims);
}

export function* requestValidatedClaimsSaga() {
  yield takeLeading(REQUEST_VALIDATED_CLAIMS, requestValidatedClaims);
}

export function* requestSearch(action: any) {
  const { token, searchQuery } = action;
  const tokenApi = token ? token : get(userToken.get(), 'token');
  const path = token
    ? `/corporeal/common/search?isIntervenant=true`
    : `/corporeal/common/search`;
  const options = {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${tokenApi}`,
    },
    body: JSON.stringify(searchQuery),
  };
  yield callApi(path, {}, options, [], setSearch);
}

export function* requestSearchSaga() {
  yield takeLeading(REQUEST_SEARCH, requestSearch);
}

export default [requestValidatedClaimsSaga, requestSearchSaga];
